import { render } from "./SliderOne.vue?vue&type=template&id=9af3e17e"
import script from "./SliderOne.vue?vue&type=script&lang=js"
export * from "./SliderOne.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\iran\\iranrpm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__